import { FaHouseFire } from "react-icons/fa6";

export default FaHouseFire;
